module.exports = __webpack_public_path__ + "static/media/grid.1a5eb55a.png";